import PhotoSwipeGallery from "./frontend/js/PhotoSwipeGallery";

/**
 * Created by sven.bluege on 04.04.2017.
 */

window.Eventgallery = require('exports-loader?Eventgallery!./common/js/EventgalleryTools.js');



require('./frontend/js/EventgalleryCart.js');
require('./frontend/js/EventgalleryBehavior.js');
require('./frontend/js/EventgalleryImage.js');
require('./frontend/js/EventgalleryRow.js');
require('./frontend/js/EventgalleryImageList.js');
require('./frontend/js/EventgalleryCart.js');
require('./frontend/js/EventgalleryEventsList.js');
require('./frontend/js/EventgalleryEventsTiles.js');
require('./frontend/js/EventgalleryGridCollection.js');
require('./frontend/js/EventgalleryJSGallery2.js');
require('./frontend/js/EventgalleryLazyload.js');
require('./frontend/js/EventgallerySizeCalculator.js');
require('./frontend/js/EventgallerySocialShareButton.js');
require('./frontend/js/EventgallerySquareList.js');
require('./frontend/js/EventgalleryTilesCollection.js');
require('./frontend/js/EventgalleryTouch.js');
require('./frontend/js/EventgalleryGooglePhotosProcessor.js');

require('./frontend/js/Modules.js');

require('./frontend/js/PhotoSwipeGallery.js');
require('./frontend/js/PhotoSwipeGallerySlide.js');

//require('./glide/dist/glide.esm.js');

require('./frontend/less/eventgallery.less');
require('./frontend/less/font-awesome/font-awesome.less');

require("./photoswipe/photoswipe.css");
require("./photoswipe/default-skin/default-skin.css");




// WEBPACK FOOTER //
// ./eventgallery.js